// @ds/actions/useCurrentEmployee — the context object + consumer hook.
//
// Split out of `CurrentEmployeeContext.tsx` so that module exports the
// provider component only.
import { createContext, useContext } from "react";
import type { Employee } from "@shared/types/employee";
import type { EmployeeRole } from "@shared/types";

export interface CurrentEmployeeValue {
  employee: Employee | null;
  roles: EmployeeRole[];
  hasRole: (...roles: EmployeeRole[]) => boolean;
}

export const CurrentEmployeeContext = createContext<CurrentEmployeeValue>({
  employee: null,
  roles: [],
  hasRole: () => false,
});

export const useCurrentEmployee = () => useContext(CurrentEmployeeContext);
